import React, { useContext } from "react";
import Registration from "../user/Registration";
import PageHelmet from "@Components/shared/PageHelmet";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";

const RegisterPage: React.FC = () => {
    const { ui: uiState } = useContext(MainContext);
    const isDesktop = uiState.mode === ViewMode.desktop;
    return (
        <div
            id="register-page"
            style={isDesktop ? { display: "flex", alignItems: "center", justifyContent: "center" } : null}
        >
            <div style={{ width: "100%" }}>
                <PageHelmet name={"Welcome"} />
                <div id="register-container">
                    <Registration />
                </div>
            </div>
        </div>
    );
};

export default RegisterPage;
